module.exports = __webpack_public_path__ + "static/media/lang-ms.fd0e3fe5.png";